import { Formik, Form } from "formik";
import FormikInput from "../../../components/FormikFieldCustom";
import { addCategoryValidationSchema } from "../../../utils/validations";
import {
  AddCategoryService,
  GetCategoryDetailService,
  UpdateCategoryService,
} from "../../../services/categories.service";
import { StatusCodes } from "http-status-codes";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import ButtonLoader from "../../../components/ButtonLoader";
import { useEffect, useState } from "react";
import { ICategoryBaseResponse } from "./category.interface";

const AddCategory = () => {
  const navigate = useNavigate();
  const [detail, setDetail] = useState<ICategoryBaseResponse | null>(null);
  const { id } = useParams();
  const GetCategoryDetails = async () => {
    const response = await GetCategoryDetailService(id as any);
    if (response.status && response.status_code === StatusCodes.OK) {
      setDetail(response?.data);
    }
  };
  useEffect(() => {
    GetCategoryDetails();
  }, [id]);
  return (
    <div className="flex justify-center items-center">
      <Formik
        enableReinitialize={id ? true : false}
        validationSchema={addCategoryValidationSchema}
        initialValues={id ? detail! : { name: "", description: "" }}
        onSubmit={async (values, { setSubmitting }) => {
          setSubmitting(true);
          if(id){
            const response = await UpdateCategoryService(id ,values);
            if (response.status && response.status_code === StatusCodes.OK) {
              toast.success(response.message);
              navigate("/admin", { state: { selectedTab: 3 } });
            } else {
              toast.error(response.message);
            }

          }else {
            const response = await AddCategoryService(values as any);
            if (response.status && response.status_code === StatusCodes.OK) {
              toast.success(response.message);
              navigate("/admin", { state: { selectedTab: 3 } });
            } else {
              toast.error(response.message);
            }
          }
          setSubmitting(false);
        
        }}
      >
        {({ isSubmitting }) => (
          <Form>
            <h1>Add Category</h1>
            <FormikInput name="name" label="Name" />
            <FormikInput name="description" label="Description" />
            <button
              type="submit"
              className="mt-3 border-2 px-1 border-gray-600 bg-gray-400"
            >
              {isSubmitting ? (
                <>
                  <ButtonLoader />
                  Loading...
                </>
              ) : (
                id ? "Save" : "Submit"
              )}
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default AddCategory;
